import {
    getOrganizationAccount,
    listOrganizationAccounts
} from './queries';
import {
    createOrganizationAccount,
    deleteOrganizationAccount,
    updateOrganizationAccount,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    OrganizationAccount,
    CreateOrganizationAccount,
    DeleteOrganizationAccount,
    GetOrganizationAccount,
    ListOrganizationAccounts,
    UpdateOrganizationAccount
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();


export const fetchRecords = async (filter: object) => {
    const response = await client.graphql<GraphQLQuery<ListOrganizationAccounts>>({
                                                                                      query: listOrganizationAccounts,
                                                                                      variables: {
                                                                                          filter: filter
                                                                                      },
                                                                                  });
    return response.data?.listOrganizationAccounts.items;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetOrganizationAccount>>({
                                                                                    query: getOrganizationAccount,
                                                                                    variables: {id: id},
                                                                                });
    return response.data?.getOrganizationAccount;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateOrganizationAccount>>({
                                                                                       query: createOrganizationAccount,
                                                                                       variables: {input: payload},
                                                                                   });
    return response.data?.createOrganizationAccount;
};

export const update = async (_id: string, record: OrganizationAccount) => {

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateOrganizationAccount>>({
                                                                                       query: (updateOrganizationAccount),
                                                                                       variables: {input: record},
                                                                                   });
    return response.data?.updateOrganizationAccount;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteOrganizationAccount>>({
                                                                                       query: (deleteOrganizationAccount),
                                                                                       variables: {input: {id: id}},

                                                                                   });
    return response.data?.deleteOrganizationAccount;
};
